import { capitalize } from 'lodash';
import Image from 'next/image';

import { Badge, Text } from '@/design-system/components/ui';
import { cn } from '@/design-system/lib/utils';

import { SelectTriggerOption } from '../TriggerTypeSelectorModal';

interface Props {
  option: SelectTriggerOption;
  selectedCount: number;
  onClick: () => void;
}

export const TriggerTypeSelectorListItem = ({ option, selectedCount, onClick }: Props) => {
  return (
    <div
      className={cn(
        'tw:w-full tw:p-4 tw:cursor-pointer tw:rounded tw:border tw:border-border tw:hover:bg-indigo-500/[0.08]',
        selectedCount > 0 && 'tw:border-fuul-blue',
      )}
      onClick={onClick}
    >
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-4">
        {typeof option.imageSrc === 'string' ? (
          <Image
            alt={option.title}
            width={32}
            height={32}
            src={option.imageSrc}
            style={{ width: 32, height: 32, objectFit: 'contain' }}
          />
        ) : (
          <div className="tw:w-8 tw:h-8 tw:flex tw:justify-center tw:items-center tw:shrink-0">{option.imageSrc}</div>
        )}
        <div className="tw:flex tw:flex-col tw:flex-1">
          <Text variant="body-sm" weight="bold">
            {option.title}
          </Text>
          <Text variant="body-sm" color="muted">
            {option.description}
          </Text>
        </div>
        <div className="tw:flex tw:flex-row tw:gap-1 tw:shrink-0">
          <Badge size="sm" variant="outline">
            {capitalize(option.category)}
          </Badge>
          {selectedCount > 0 && <Badge size="sm">{selectedCount}</Badge>}
        </div>
      </div>
    </div>
  );
};
